import { z } from 'zod';
import { zStringRequired } from '../../z';
import { refineSchema } from '../refine-schema';
import { registry } from '../registry';
const yesNoOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
];
export const baseHHASupervisory = z.object({
    hhaPresent: zStringRequired().register(registry, { label: 'HHA aide present at the time of the visit', options: yesNoOptions }),
    clinicianName: z.string().optional().register(registry, { label: 'Name' }),
    ptInterviewed: zStringRequired().register(registry, { label: 'Patient/family interviewed', options: yesNoOptions }),
    observedCare: zStringRequired().register(registry, { label: 'Observed care provided', options: yesNoOptions }),
    caringAttitude: zStringRequired().register(registry, {
        label: 'Demonstrates a kind and caring manner toward the patient and family',
        options: yesNoOptions,
    }),
    confidentiality: zStringRequired().register(registry, { label: 'Maintains confidentiality', options: yesNoOptions }),
    openCommunication: zStringRequired().register(registry, {
        label: 'Maintains open communication (explains actions; asks and responds to feedback)',
        options: yesNoOptions,
    }),
    followHHAPOC: zStringRequired().register(registry, { label: 'Follows the HHA aide plan of care', options: yesNoOptions }),
    safeEffectiveCare: zStringRequired().register(registry, { label: 'Provides safe and effective care', options: yesNoOptions }),
    infectionPrevention: zStringRequired().register(registry, {
        label: 'Maintains infection prevention and control practices',
        options: yesNoOptions,
    }),
    cleanEnvironment: zStringRequired().register(registry, { label: 'Maintains a clean working environment', options: yesNoOptions }),
    ptBenefittingHHAaid: zStringRequired().register(registry, {
        label: 'Patient is benefitting from HHA aide care',
        options: yesNoOptions,
    }),
    aidSameFrequency: zStringRequired().register(registry, {
        label: 'Will continue aides at the same frequency',
        options: yesNoOptions,
    }),
    aidPlanUpdated: zStringRequired().register(registry, { label: 'HHA aide care plan updated', options: yesNoOptions }),
    aidPlanUpdatedComment: z.string().optional().register(registry, { label: 'Explain' }),
});
export const hhaSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: refineSchema(baseHHASupervisory, (input, ctx) => {
            const payload = input;
            if (payload.hhaPresent === 'yes' && !payload.clinicianName) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please select a clinician',
                    path: ['clinicianName'],
                });
            }
            if (payload.aidPlanUpdated === 'yes' && !payload.aidPlanUpdatedComment) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please enter changes to the care plan',
                    path: ['aidPlanUpdatedComment'],
                });
            }
        }),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
